import React, { useState, useEffect, useRef } from "react";
import {
  Select,
  MenuItem,
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Modal,
} from "@mui/material";
import GoogleMapsAutoComplete from "../components/GoogleMapsAutoComplete";
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from "../components/AlertDialog";
import { makeStyles } from "@mui/styles";
import UsersCombo from "../components/UsersCombo";
import { api } from "common";
import Button from "components/CustomButtons/Button.js";
import { useTranslation } from "react-i18next";
import { colors } from "../components/Theme/WebTheme";
import { BookingModalBody, validateBookingObj } from "common/sharedFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress";
import { GoogleMapApiConfig } from "../config/GoogleMapApiConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  container: {
    marginTop: theme.spacing(1),
    backgroundColor: colors.SECONDARY,
    alignContent: "center",
    borderRadius: "8px",
    width: "70%",
  },
  container1: {
    backgroundColor: colors.WHITE,
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    padding: "30px",
    width: "100%",
    top: "19px",
    boxShadow: "4px 4px 6px #9E9E9E",
  },
  title: {
    color: colors.WHITE,
    padding: "10px",
  },
  gridcontainer: {
    alignContent: "center",
  },
  items: {
    margin: 0,
    width: "100%",
  },
  input: {
    fontSize: 18,
    color: "#000",
  },
  inputdimmed: {
    fontSize: 18,
    color: colors.THIRDCOLOR,
  },
  carphoto: {
    height: "18px",
    marginRight: "10px",
  },
  carphotoRtl: {
    height: "16px",
    marginLeft: "10px",
  },
  buttonStyle: {
    margin: 0,
    width: "100%",
    height: 40,
    borderRadius: "30px",
    backgroundColor: colors.MAIN_COLOR,
    color: "#FFF",
  },
  inputRtl: {
    "& label": {
      right: 25,
      left: "auto",
    },
    "& legend": {
      textAlign: "right",
      marginRight: 18,
    },
  },
  rightRty: {
    "& legend": {
      marginRight: 30,
    },
  },
}));

const icons = {
  paypal: require("../assets/payment-icons/paypal-logo.png").default,
  stripe: require("../assets/payment-icons/stripe-logo.png").default,
};

export default function AddBookings(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    getEstimate,
    clearEstimate,
    addBooking,
    clearBooking,
    MinutesPassed,
    GetDateString,
    GetDistance,
    updateBooking,
    updateProfileWithEmail,
    checkUserExists,
    updateProfile,
  } = api;
  const dispatch = useDispatch();
  const classes = useStyles();
  const cartypes = useSelector((state) => state.cartypes.cars);
  const estimatedata = useSelector((state) => state.estimatedata);
  const bookingdata = useSelector((state) => state.bookingdata);
  const userdata = useSelector((state) => state.usersdata);
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings);
  const providers = useSelector((state) => state.paymentmethods.providers);
  const activeBookings = useSelector((state) => state.bookinglistdata.active);
  const [carType, setCarType] = useState(t("select_car"));
  const [pickupAddress, setPickupAddress] = useState(null);
  const [dropAddress, setDropAddress] = useState(null);
  const [optionModalStatus, setOptionModalStatus] = useState(false);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  const [users, setUsers] = useState(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [userCombo, setUserCombo] = useState(null);
  const [estimateRequested, setEstimateRequested] = useState(false);
  const [bookingType, setBookingType] = useState("Book Now");
  const rootRef = useRef(null);
  const [tempRoute, setTempRoute] = useState();
  const [drivers, setDrivers] = useState([]);
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const [walletModalStatus, setWalletModalStatus] = useState(false);
  const { state } = useLocation();
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [tripInstructions, setTripInstructions] = useState("");
  const [loading, setLoading] = useState(false);
  const [bookingOnWait, setBookingOnWait] = useState();
  const [selectedCategory, setSelectedCategory] = useState(
    t("select_category")
  );
  const categorylistdata = useSelector((state) => state.categorylistdata);
  const [categories, setCategories] = useState([]);
  const [hours, setHours] = useState(2);
  // state for rebid module
  const [bidPrice, setBidPrice] = useState(null);
  const [useRebidMod, setUseRebidMod] = useState(false);
  const [isBookingLoading, setIsBookingLoading] = useState(false);
  const [isWalletPaymentLoading, setIsWalletPaymentLoading] = useState(false);

  const instructioInitData = {
    deliveryPerson: "",
    deliveryPersonPhone: "",
    pickUpInstructions: "",
    deliveryInstructions: "",
    parcelTypeIndex: 0,
    optionIndex: 0,
    parcelTypeSelected: null,
    optionSelected: null,
  };
  const [instructionData, setInstructionData] = useState(instructioInitData);

  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const [payment_mode, setPaymentMode] = useState(0);
  const [radioProps, setRadioProps] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (settings && providers) {
      setSelectedProvider(providers[0]);
      const paymentMethods = api.getAvailablePaymentMethods(
        settings,
        providers,
        t
      );
      setRadioProps(paymentMethods);
    }
    let rebid = settings && settings.UseRebidMode ? true : false;
    setUseRebidMod(rebid);
  }, [settings, providers, t]);

  useEffect(() => {
    if (categorylistdata.categories && categorylistdata.categories.length > 1) {
      let lst = categorylistdata.categories;
      for (let i = 0; i < lst.length; i++) {
        if (lst[i].active) {
          setSelectedCategory(lst[i].category);
          break;
        }
      }
      setCategories(categorylistdata.categories);
    }
  }, [categorylistdata.categories]);

  useEffect(() => {
    if (state && state !== null) {
      let carDetails = state.carData;
      setCarType(carDetails.name);
      let instObj = { ...instructionData };
      if (Array.isArray(carDetails.parcelTypes)) {
        instObj.parcelTypeSelected = carDetails.parcelTypes[0];
        instObj.parcelTypeIndex = 0;
      }
      if (Array.isArray(carDetails.options)) {
        instObj.optionSelected = carDetails.options[0];
        instObj.optionIndex = 0;
      }
      setInstructionData(instObj);
      setSelectedCarDetails(carDetails);
    }
  }, [instructionData, state]);

  const changeEstimate = (iData) => {
    let estimateRequest = {
      pickup: pickupAddress,
      drop: dropAddress,
      carDetails: selectedCarDetails,
      instructionData: iData,
      routeDetails:
        selectedCategory === "rentals"
          ? { ...tempRoute, time_in_secs: hours * 60 * 60 }
          : tempRoute,
    };
    dispatch(getEstimate(estimateRequest));
  };

  const handleChange = (e) => {
    if (e.target.name === "parcelTypeIndex") {
      let iData = {
        ...instructionData,
        parcelTypeIndex: parseInt(e.target.value),
        parcelTypeSelected: selectedCarDetails.parcelTypes[e.target.value],
      };
      setInstructionData(iData);
      changeEstimate(iData);
    } else if (e.target.name === "optionIndex") {
      let iData = {
        ...instructionData,
        optionIndex: parseInt(e.target.value),
        optionSelected: selectedCarDetails.options[e.target.value],
      };
      setInstructionData(iData);
      changeEstimate(iData);
    } else if (e.target.name === "payment_mode") {
      setPaymentMode(e.target.value);
    } else if (e.target.name === "selectedProviderIndex") {
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    } else if (e.target.name === "tripInstructions") {
      setTripInstructions(e.target.value);
    } else if (e.target.name === "bidPrice") {
      // added for rebid mod
      setBidPrice(e.target.value); // added for rebid mod
    } else if (e.target.name === "firstName") {
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    } else if (e.target.name === "lastName") {
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    } else if (e.target.name === "email") {
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    } else {
      setInstructionData({
        ...instructionData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const [selectedDate, setSelectedDate] = useState(GetDateString());

  const clearForm = () => {
    setUserCombo(null);
    setPickupAddress(null);
    setDropAddress(null);
    setSelectedCarDetails(null);
    setCarType(t("select_car"));
    setBookingType("Book Now");
    setEstimateRequested(false);
  };

  useEffect(() => {
    if (auth.profile && bookingOnWait) {
      //setEstimateModalStatus(false);
      setIsBookingLoading(true);
      dispatch(addBooking(bookingOnWait));
      setBookingOnWait(null);
      setLoading(false);
    }
  }, [auth.profile, bookingOnWait, dispatch, addBooking]);

  // Clear loading when booking succeeds or fails
  useEffect(() => {
    if (bookingdata.booking && bookingdata.booking.mainData) {
      setIsBookingLoading(false);
      // Close modal after booking succeeds
      setOptionModalStatus(false);
    }
    if (bookingdata.error.flag) {
      setIsBookingLoading(false);
      // Keep modal open on error so user can see the error and retry
    }
  }, [bookingdata.booking, bookingdata.error]);

  useEffect(() => {
    if (
      bookingdata.booking &&
      bookingdata.booking.mainData.status === "PAYMENT_PENDING"
    ) {
      if (bookingdata.booking.mainData.payment_mode === "cash" || bookingdata.booking.mainData.payment_mode === "yape") {
        dispatch(clearBooking());
        setTempRoute(null);
        navigate("/bookings");
      } else {
        if (bookingdata.booking.mainData.payment_mode === "card") {
          setPaymentModalStatus(true);
        } else {
          setWalletModalStatus(true);
        }
      }
    }
    if (bookingdata.booking && bookingdata.booking.mainData.status === "NEW") {
      dispatch(clearBooking());
      setTempRoute(null);
      navigate("/bookings");
    }
  }, [bookingdata.booking, clearBooking, dispatch, navigate]);

  const handleCategorySelect = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedCarDetails(null);
    setCarType(t("select_car"));
  };

  const handleCarSelect = (event) => {
    setCarType(event.target.value);
    let carDetails = null;
    for (let i = 0; i < cartypes.length; i++) {
      if (
        cartypes[i].name === event.target.value &&
        cartypes[i].category === selectedCategory
      ) {
        carDetails = cartypes[i];
        let instObj = { ...instructionData };
        if (Array.isArray(cartypes[i].parcelTypes)) {
          instObj.parcelTypeSelected = cartypes[i].parcelTypes[0];
          instObj.parcelTypeIndex = 0;
        }
        if (Array.isArray(cartypes[i].options)) {
          instObj.optionSelected = cartypes[i].options[0];
          instObj.optionIndex = 0;
        }
        setInstructionData(instObj);
        setSelectedCarDetails(carDetails);
      }
    }
  };

  const handleBookTypeSelect = (event) => {
    setBookingType(event.target.value);
    if (bookingType === "Book Later") {
      setSelectedDate(GetDateString());
    }
  };

  const onDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  useEffect(() => {
    if (estimatedata.estimate && estimateRequested) {
      setEstimateRequested(false);
      setOptionModalStatus(true);
    }
    if (estimatedata.error.flag && estimateRequested) {
      setEstimateRequested(false);
    }
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (
          user.usertype === "customer" &&
          ((auth.profile.usertype === "fleetadmin" &&
            user.fleetadmin === auth.profile.uid) ||
            auth.profile.usertype === "admin")
        ) {
          arr.push({
            firstName: user.firstName,
            lastName: user.lastName,
            mobile: user.mobile,
            email: user.email,
            uid: user.id,
            desc:
              user.firstName +
              " " +
              user.lastName +
              " (" +
              (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
              ") " +
              (settings.AllowCriticalEditsAdmin ? user.email : "Hidden"),
            pushToken: user.pushToken ? user.pushToken : "",
            country: user.country_code,
            currency: user.currency_code,
            fleetadminrider: user.fleetadmin,
          });
        }
      }
      setUsers(arr);
      let arrDrivers = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (
          user.usertype &&
          user.usertype === "driver" &&
          user.approved === true &&
          user.queue === false &&
          user.driverActiveStatus === true &&
          user.location
        ) {
          if (
            (auth.profile.usertype === "fleetadmin" &&
              user.fleetadmin === auth.profile.uid) ||
            auth.profile.usertype === "admin" ||
            auth.profile.usertype === "customer"
          ) {
            arrDrivers.push({
              uid: user.id,
              location: user.location,
              carType: user.carType,
              fleetadmin: user.fleetadmin ? user.fleetadmin : null,
              category: user.category,
            });
          }
        }
      }
      setDrivers(arrDrivers);
    }
  }, [
    estimatedata.estimate,
    userdata.users,
    estimateRequested,
    settings.AllowCriticalEditsAdmin,
    auth.profile.usertype,
    auth.profile.uid,
  ]);

  useEffect(() => {
    if (auth.profile.usertype && auth.profile.usertype === "customer") {
      setUserCombo({
        firstName: auth.profile.firstName,
        lastName: auth.profile.lastName,
        mobile: auth.profile.mobile,
        email: auth.profile.email,
        uid: auth.profile.uid,
        pushToken: auth.profile.pushToken ? auth.profile.pushToken : "",
        currency: auth.profile.currency_code,
        country: auth.profile.country_code,
        fleetadminrider: auth.profile.fleetadmin
          ? auth.profile.fleetadmin
          : null,
      });
    }
  }, [auth.profile]);

  const mobile = userCombo && userCombo.mobile ? true : false;

  const handleGetOptions = (e) => {
    e.preventDefault();
    setEstimateRequested(true);
    if (
      (settings &&
        settings.imageIdApproval &&
        auth.profile.usertype === "customer" &&
        auth.profile.verifyId) ||
      auth.profile.usertype === "admin" ||
      (settings &&
        !settings.imageIdApproval &&
        auth.profile.usertype === "customer") ||
      auth.profile.usertype === "fleetadmin"
    ) {
      if (
        !(
          settings &&
          settings.disable_cash &&
          (auth.profile.usertype === "admin" ||
            auth.profile.usertype === "fleetadmin")
        ) ||
        auth.profile.usertype === "customer"
      ) {
        if (
          (auth.profile.usertype === "customer" &&
            parseFloat(auth.profile.walletBalance) >= 0) ||
          ((auth.profile.usertype === "admin" ||
            auth.profile.usertype === "fleetadmin") &&
            userCombo.firstName &&
            userCombo.firstName.length > 0 &&
            userCombo.lastName &&
            userCombo.lastName.length > 0 &&
            userCombo.email &&
            userCombo.email.length > 0)
        ) {
          if (userCombo && pickupAddress && dropAddress && selectedCarDetails) {
            // Using the new Routes API
            const apiKey = GoogleMapApiConfig;

            // Create the request body
            const requestData = {
              origin: {
                location: {
                  latLng: {
                    latitude: pickupAddress.coords.lat,
                    longitude: pickupAddress.coords.lng,
                  },
                },
              },
              destination: {
                location: {
                  latLng: {
                    latitude: dropAddress.coords.lat,
                    longitude: dropAddress.coords.lng,
                  },
                },
              },
              travelMode: "DRIVE",
              routingPreference: "TRAFFIC_AWARE",
              computeAlternativeRoutes: false,
              routeModifiers: {
                avoidTolls: false,
                avoidHighways: false,
                avoidFerries: false,
              },
              languageCode: "en-US",
              units: "METRIC",
            };

            // Create request headers
            const headers = {
              "Content-Type": "application/json",
              "X-Goog-Api-Key": apiKey,
              "X-Goog-FieldMask":
                "routes.duration,routes.distanceMeters,routes.polyline.encodedPolyline",
            };

            // Make the fetch call to the Routes API
            fetch("https://routes.googleapis.com/directions/v2:computeRoutes", {
              method: "POST",
              headers: headers,
              body: JSON.stringify(requestData),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data && data.routes && data.routes.length > 0) {
                  const routeData = data.routes[0];

                  // Create a route object in the same format expected by the rest of the code
                  const route = {
                    distance_in_km: routeData.distanceMeters / 1000,
                    time_in_secs: parseInt(
                      routeData.duration.substring(
                        0,
                        routeData.duration.length - 1
                      )
                    ), // Remove 's' and convert to integer
                    polylinePoints: routeData.polyline.encodedPolyline,
                  };

                  setTempRoute(route);

                  if (pickupAddress && dropAddress) {
                    if (bookingType === "Book Now") {
                      if (mobile === true) {
                        let estimateRequest = {
                          pickup: pickupAddress,
                          drop: dropAddress,
                          carDetails: selectedCarDetails,
                          instructionData: instructionData,
                          routeDetails:
                            selectedCategory === "rentals"
                              ? { ...route, time_in_secs: hours * 60 * 60 }
                              : route,
                        };
                        dispatch(getEstimate(estimateRequest));
                      } else {
                        setEstimateRequested(false);
                        setCommonAlert({
                          open: true,
                          msg: t("incomplete_user"),
                        });
                      }
                    } else {
                      if (bookingType === "Book Later" && selectedDate) {
                        if (MinutesPassed(selectedDate) >= 15) {
                          if (mobile === true) {
                            let estimateRequest = {
                              pickup: pickupAddress,
                              drop: dropAddress,
                              carDetails: selectedCarDetails,
                              instructionData: instructionData,
                              routeDetails:
                                selectedCategory === "rentals"
                                  ? { ...route, time_in_secs: hours * 60 * 60 }
                                  : route,
                            };
                            dispatch(getEstimate(estimateRequest));
                          } else {
                            setEstimateRequested(false);
                            setCommonAlert({
                              open: true,
                              msg: t("incomplete_user"),
                            });
                          }
                        } else {
                          setEstimateRequested(false);
                          setCommonAlert({
                            open: true,
                            msg: t("past_booking_error"),
                          });
                        }
                      } else {
                        setEstimateRequested(false);
                        setCommonAlert({ open: true, msg: t("select_proper") });
                      }
                    }
                  } else {
                    setEstimateRequested(false);
                    setCommonAlert({
                      open: true,
                      msg: t("place_to_coords_error"),
                    });
                  }
                } else {
                  console.error("Invalid response from Routes API", data);
                  setCommonAlert({ open: true, msg: t("route_not_found") });
                  setEstimateRequested(false);
                }
              })
              .catch((error) => {
                console.error("Error calling Routes API:", error);
                setCommonAlert({
                  open: true,
                  msg: t("route_calculation_error"),
                });
                setEstimateRequested(false);
              });
          } else {
            setEstimateRequested(false);
            setCommonAlert({ open: true, msg: t("select_proper") });
          }
        } else {
          setEstimateRequested(false);
          if (
            auth.profile.usertype === "admin" ||
            auth.profile.usertype === "fleetadmin"
          ) {
            setCommonAlert({ open: true, msg: t("selectUserDetailMissing") });
          } else {
            setCommonAlert({ open: true, msg: t("wallet_balance_low") });
          }
        }
      } else {
        setEstimateRequested(false);
        setCommonAlert({ open: true, msg: t("cash_booking_false") });
      }
    } else {
      setEstimateRequested(false);
      setCommonAlert({ open: true, msg: t("verifyid_error") });
    }
  };

  const handleWalletPayment = (e) => {
    e.preventDefault();
    setIsWalletPaymentLoading(true);
    let curBooking = { ...bookingdata.booking.mainData };
    if (
      parseFloat(curBooking.trip_cost) >
        parseFloat(auth.profile.walletBalance) &&
      radioProps[payment_mode].cat === "wallet"
    ) {
      setIsWalletPaymentLoading(false);
      setCommonAlert({ open: true, msg: t("wallet_balance_low") });
    } else {
      let requestedDrivers = {};
      if (settings.autoDispatch && bookingType === "Book Now") {
        for (let i = 0; i < drivers.length; i++) {
          const driver = drivers[i];
          let distance = GetDistance(
            pickupAddress.coords.lat,
            pickupAddress.coords.lng,
            driver.location.lat,
            driver.location.lng
          );
          if (settings.convert_to_mile) {
            distance = distance / 1.609344;
          }
          if (
            distance <
              (settings && settings.driverRadius
                ? settings.driverRadius
                : 10) &&
            ((settings.carType_required &&
              ((settings.multi_service) ||
              (!settings.multi_service && selectedCarDetails.name === driver.carType &&
              selectedCategory === driver.category))) ||
              !settings.carType_required)
          ) {
            requestedDrivers[driver["uid"]] = true;
          }
        }
      }
      curBooking.prepaid = true;
      curBooking.status = "NEW";
      curBooking.payment_mode = "wallet";
      curBooking.customer_paid = parseFloat(curBooking.trip_cost).toFixed(
        settings.decimal
      );
      curBooking.discount = 0;
      curBooking.usedWalletMoney = parseFloat(curBooking.trip_cost).toFixed(
        settings.decimal
      );
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount = 0;
      curBooking.requestedDrivers = requestedDrivers;

      dispatch(updateBooking(curBooking));

      setTimeout(() => {
        setIsWalletPaymentLoading(false);
        dispatch(clearEstimate());
        setPaymentModalStatus(false);
        setWalletModalStatus(false);
        clearForm();
        dispatch(clearBooking());
        setTempRoute(null);
        navigate("/bookings");
      }, 1500);
    }
  };

  const confirmBooking = async (e) => {
    e.preventDefault();
    setIsBookingLoading(true);
    
    // Check customer subscription before booking (only for customers)
    if (auth.profile.usertype === "customer") {
      try {
        console.log("🔍 Checking customer subscription before booking...");
        const response = await fetch(
          `${window.location.origin}/subscription-checkTripUsage`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              userId: userCombo.uid || auth.profile.uid,
              action: 'check',
              userType: 'customer'
            })
          }
        );
        
        const subscriptionData = await response.json();
        
        if (!subscriptionData.canTakeTrip) {
          console.log("❌ Customer subscription check failed:", subscriptionData.reason);
          setIsBookingLoading(false);
          setCommonAlert({
            open: true,
            msg: subscriptionData.reason || t("subscription_required_message")
          });
          return;
        }
        console.log("✅ Customer subscription check passed");
      } catch (error) {
        console.error("❌ Error checking customer subscription:", error);
        // If subscription check fails, allow booking to proceed (fail-safe)
        console.log("⚠️ Subscription check failed, allowing booking to proceed");
      }
    }
    
    let requestedDrivers = {};
    let driverEstimates = {};

    let notfound = true;
    if (activeBookings) {
      for (let i = 0; i < activeBookings.length; i++) {
        if (
          activeBookings[i].payment_mode === "wallet" &&
          activeBookings[i].status !== "PAID"
        ) {
          notfound = false;
          break;
        }
      }
    }

    // rebid module check for empty quote
    if (useRebidMod && !bidPrice && selectedCarDetails.hasBid) {
      setIsBookingLoading(false);
      setCommonAlert({ open: true, msg: t("enter_bid_amt") });
      return;
    }

    if (
      (radioProps[payment_mode].cat === "wallet" &&
        notfound &&
        auth.profile.usertype === "customer") ||
      radioProps[payment_mode].cat !== "wallet" ||
      auth.profile.usertype === "admin" ||
      auth.profile.usertype === "fleetadmin"
    ) {
      if (
        (radioProps[payment_mode].cat === "wallet" &&
          parseFloat(auth.profile.walletBalance) >=
            parseFloat(estimatedata.estimate.estimateFare) &&
          selectedCategory === "delivery" &&
          auth.profile.usertype === "customer") ||
        radioProps[payment_mode].cat !== "wallet" ||
        (radioProps[payment_mode].cat === "wallet" &&
          selectedCategory !== "delivery" &&
          auth.profile.usertype === "customer") ||
        auth.profile.usertype === "admin" ||
        auth.profile.usertype === "fleetadmin"
      ) {
        if (settings.autoDispatch && bookingType === "Book Now") {
          for (let i = 0; i < drivers.length; i++) {
            const driver = drivers[i];
            let distance = GetDistance(
              pickupAddress.coords.lat,
              pickupAddress.coords.lng,
              driver.location.lat,
              driver.location.lng
            );
            if (settings.convert_to_mile) {
              distance = distance / 1.609344;
            }
            // Check if driver can handle this car type
            let canHandleCarType = false;
            
            if (settings.carType_required) {
              // For multi-service system, check cars collection and ignore category
              if (settings.multi_service) {
                // Note: For multi-service, car type validation is handled by client side
                // when fetching cars from cars collection. Here we assume driver has valid cars.
                canHandleCarType = true;
              }
              // For single-service system, check carType only (no category check)
              else if (driver.carType) {
                canHandleCarType = driver.carType === selectedCarDetails.name;
              }
            } else {
              canHandleCarType = true; // No car type requirement
            }
            
            if (
              distance <
                (settings && settings.driverRadius
                  ? settings.driverRadius
                  : 10) &&
              canHandleCarType &&
              ((auth.profile.usertype === "fleetadmin" &&
                driver.fleetadmin === auth.profile.uid) ||
                auth.profile.usertype !== "fleetadmin")
            ) {
              requestedDrivers[driver["uid"]] = true;
              driverEstimates[driver["uid"]] = {
                distance: distance,
                timein_text: (distance * 2 + 1).toFixed(0) + " min",
              };
            }
          }
          if (Object.keys(requestedDrivers).length === 0) {
            setIsBookingLoading(false);
            setCommonAlert({
              open: true,
              msg: t("no_driver_found_alert_messege"),
            });
            return;
          }
        }

        let bookingObject = {
          pickup: pickupAddress,
          drop: dropAddress,
          carDetails: selectedCarDetails,
          userDetails: {
            uid: userCombo.uid,
            firstName: userCombo.firstName,
            lastName: userCombo.lastName,
            mobile: userCombo.mobile,
            pushToken: userCombo.pushToken,
            email: userCombo.email,
            country_code: userCombo.country,
            currency_code: userCombo.currency,
          },
          estimate: estimatedata.estimate,
          instructionData: instructionData,
          tripInstructions: tripInstructions,
          tripdate:
            bookingType === "Book Later"
              ? new Date(selectedDate).getTime()
              : new Date().getTime(),
          bookLater: bookingType === "Book Later" ? true : false,
          // For Book Later, set payment status based on payment mode
          payment_status: bookingType === "Book Later" ? 
            (radioProps[payment_mode].cat === "wallet" ? "PAID" : "PENDING") : 
            "PENDING",
          settings: settings,
          booking_type_admin: auth.profile.usertype === "admin" ? true : false,
          fleetadmin:
            auth.profile.usertype === "fleetadmin" ? auth.profile.uid : null,
          fleetadminrider: userCombo.fleetadminrider
            ? userCombo.fleetadminrider
            : null,
          requestedDrivers: selectedCarDetails.hasBid
            ? requestedDrivers
            : radioProps[payment_mode].cat === "cash" ||
              radioProps[payment_mode].cat === "yape"
            ? requestedDrivers
            : requestedDrivers,
          driverEstimates: driverEstimates,
          payment_mode:
            auth.profile.usertype === "admin" ||
            auth.profile.usertype === "fleetadmin"
              ? "cash"
              : radioProps[payment_mode].cat,
          booking_from_web: true,
          hasBid: selectedCarDetails.hasBid,
          bidPrice: !bidPrice ? null : bidPrice,
        };

        if (
          auth.profile.usertype === "customer" &&
          !(
            auth.profile.firstName &&
            auth.profile.lastName &&
            auth.profile.email &&
            auth.profile.firstName.length > 0 &&
            auth.profile.lastName.length > 0 &&
            auth.profile.email.length > 0
          )
        ) {
          const regx1 =
            /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
          if (
            (selectedCategory === "delivery" &&
              /\S/.test(instructionData.deliveryPerson) &&
              regx1.test(instructionData.deliveryPersonPhone) &&
              instructionData.deliveryPersonPhone &&
              instructionData.deliveryPersonPhone.length > 6) ||
            selectedCategory !== "delivery"
          ) {
            if (
              (profileData.firstName &&
                profileData.firstName.length > 0 &&
                profileData.lastName &&
                profileData.lastName.length > 0) ||
              (auth.profile.firstName &&
                auth.profile.firstName.length > 0 &&
                auth.profile.lastName &&
                auth.profile.lastName.length > 0)
            ) {
              const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (
                (re.test(profileData.email) && !auth.profile.email) ||
                (auth.profile.email && auth.profile.email.length > 0)
              ) {
                setLoading(true);
                checkUserExists({ email: profileData.email }).then(
                  async (res) => {
                    if (res.users && res.users.length > 0) {
                      setLoading(false);
                      alert(t("user_exists"));
                    } else {
                      setLoading(false);
                      if (radioProps[payment_mode].cat === "card") {
                        const paymentPacket = {
                          payment_mode: "card",
                          customer_paid: parseFloat(
                            estimatedata.estimate.estimateFare
                          ).toFixed(settings.decimal),
                          cardPaymentAmount: parseFloat(
                            estimatedata.estimate.estimateFare
                          ).toFixed(settings.decimal),
                          discount: 0,
                          usedWalletMoney: 0,
                          cashPaymentAmount: 0,
                          promo_applied: false,
                          promo_details: null,
                          payableAmount: parseFloat(
                            estimatedata.estimate.estimateFare
                          ).toFixed(settings.decimal),
                        };
                        bookingObject["paymentPacket"] = paymentPacket;
                      }

                      const result = validateBookingObj(
                        t,
                        bookingObject,
                        instructionData,
                        selectedCarDetails
                      );
                      if (result.error) {
                        setCommonAlert({ open: true, msg: result.msg });
                      } else {
                        profileData["uid"] = auth.profile.uid;
                        let bookingData = result.bookingObject;
                        bookingData.userDetails.firstName =
                          profileData.firstName;
                        bookingData.userDetails.lastName = profileData.lastName;
                        bookingData.userDetails.email = profileData.email;
                        setBookingOnWait(bookingData);
                      }
                      if (auth.profile.email && auth.profile.email.length > 0) {
                        let userData = {
                          firstName: profileData.firstName,
                          lastName: profileData.lastName,
                        };
                        dispatch(updateProfile(userData));
                      } else {
                        setTimeout(() => {
                          dispatch(updateProfileWithEmail(profileData));
                        }, 200);
                      }
                    }
                  }
                );
              } else {
                setCommonAlert({ open: true, msg: t("proper_email") });
              }
            } else {
              setCommonAlert({ open: true, msg: t("proper_input_name") });
            }
          } else {
            setCommonAlert({ open: true, msg: t("deliveryDetailMissing") });
          }
        } else {
          if (radioProps[payment_mode].cat === "card") {
            const paymentPacket = {
              payment_mode: "card",
              customer_paid: parseFloat(
                estimatedata.estimate.estimateFare
              ).toFixed(settings.decimal),
              cardPaymentAmount: parseFloat(
                estimatedata.estimate.estimateFare
              ).toFixed(settings.decimal),
              discount: 0,
              usedWalletMoney: 0,
              cashPaymentAmount: 0,
              promo_applied: false,
              promo_details: null,
              payableAmount: parseFloat(
                estimatedata.estimate.estimateFare
              ).toFixed(settings.decimal),
            };
            bookingObject["paymentPacket"] = paymentPacket;
          }
          const result = validateBookingObj(
            t,
            bookingObject,
            instructionData,
            selectedCarDetails
          );
          if (result.error) {
            setIsBookingLoading(false);
            setCommonAlert({ open: true, msg: result.msg });
          } else {
            // Keep modal open to show loading indicator
            // Modal will be closed when booking succeeds or fails via useEffect
            dispatch(addBooking(result.bookingObject));
            // Loading will be cleared when booking succeeds or fails via useEffect
          }
        }
      } else {
        setIsBookingLoading(false);
        setCommonAlert({ open: true, msg: t("wallet_balance_low") });
      }
    } else {
      setIsBookingLoading(false);
      setCommonAlert({ open: true, msg: t("wallet_booking_alert") });
    }
  };

  const handleOptionModalClose = (e) => {
    e.preventDefault();
    // Prevent closing modal during booking process
    if (isBookingLoading) {
      return;
    }
    setOptionModalStatus(false);
    dispatch(clearEstimate());
    setInstructionData(instructioInitData);
    setIsBookingLoading(false);
  };

  const handleEstimateErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    setEstimateRequested(false);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleWalletModalClose = (e) => {
    setTimeout(() => {
      setWalletModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    }, 1500);
  };

  const handlePaymentModalClose = (e) => {
    setTimeout(() => {
      setPaymentModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    }, 1500);
  };

  const handleHoursChange = (event, newValue) => {
    if (typeof newValue === "number") {
      setHours(newValue);
      let estimateRequest = {
        pickup: pickupAddress,
        drop: dropAddress,
        carDetails: selectedCarDetails,
        instructionData: instructionData,
        routeDetails: { ...tempRoute, time_in_secs: newValue * 60 * 60 },
      };
      dispatch(getEstimate(estimateRequest));
    }
  };

  const handleIHoursAdd = () => {
    if (hours < 18) {
      setHours(hours + 1);
      let estimateRequest = {
        pickup: pickupAddress,
        drop: dropAddress,
        carDetails: selectedCarDetails,
        instructionData: instructionData,
        routeDetails: { ...tempRoute, time_in_secs: (hours + 1) * 60 * 60 },
      };
      dispatch(getEstimate(estimateRequest));
    }
  };
  const handleIHoursSubtruct = () => {
    if (hours > 1) {
      setHours(hours - 1);
      let estimateRequest = {
        pickup: pickupAddress,
        drop: dropAddress,
        carDetails: selectedCarDetails,
        instructionData: instructionData,
        routeDetails: { ...tempRoute, time_in_secs: (hours - 1) * 60 * 60 },
      };
      dispatch(getEstimate(estimateRequest));
    }
  };

  return (
    <div className={classes.container} ref={rootRef}>
      <Grid item xs={12} sm={12} md={8} lg={8}>
        <Grid item xs={12}>
          <Typography
            component="h1"
            variant="h5"
            className={classes.title}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {t("addbookinglable")}
          </Typography>
        </Grid>
        <div className={classes.container1}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {users &&
              auth.profile.usertype &&
              auth.profile.usertype !== "customer" ? (
                <UsersCombo
                  className={classes.items}
                  placeholder={t("select_user")}
                  users={users}
                  value={userCombo}
                  onChange={(event, newValue) => {
                    setUserCombo(newValue);
                  }}
                />
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <GoogleMapsAutoComplete
                variant={"outlined"}
                placeholder={t("pickup_location")}
                value={pickupAddress}
                className={classes.items}
                onChange={(value) => {
                  setPickupAddress(value);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <GoogleMapsAutoComplete
                placeholder={t("drop_location")}
                variant={"outlined"}
                value={dropAddress}
                className={classes.items}
                onChange={(value) => {
                  setDropAddress(value);
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={4}
              style={{
                display:
                  settings &&
                  settings.ServicesEnabledKey &&
                  settings.ServicesEnabledKey !== "All"
                    ? "none"
                    : "block",
              }}
            >
              {cartypes && categories ? (
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedCategory}
                  onChange={handleCategorySelect}
                  variant="outlined"
                  fullWidth
                  style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                  className={
                    carType === t("select_category")
                      ? classes.inputdimmed
                      : classes.input
                  }
                >
                  <MenuItem
                    dense={true}
                    value={t("select_category")}
                    key={t("select_category")}
                    style={{
                      direction: isRTL === "rtl" ? "rtl" : "ltr",
                      width: "100%",
                      justifyContent: "flex-start",
                      paddingLeft: 10,
                    }}
                  >
                    {t("select_category")}
                  </MenuItem>
                  {categories.map((item) => (
                    <MenuItem
                      dense={true}
                      key={item.category}
                      value={item.category}
                      style={{
                        direction: isRTL === "rtl" ? "rtl" : "ltr",
                        width: "100%",
                        justifyContent: "flex-start",
                        paddingLeft: 10,
                      }}
                    >
                      <img
                        src={item.cat_image}
                        className={
                          isRTL === "rtl"
                            ? classes.carphotoRtl
                            : classes.carphoto
                        }
                        alt="car types"
                      />
                      {t(item.category)}
                    </MenuItem>
                  ))}
                </Select>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={5}>
              {cartypes.filter(
                (carT) =>
                  carT.category === selectedCategory && carT.active === true
              ) ? (
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={carType}
                  onChange={handleCarSelect}
                  variant="outlined"
                  fullWidth
                  style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                  className={
                    carType === t("select_car")
                      ? classes.inputdimmed
                      : classes.input
                  }
                >
                  <MenuItem
                    dense={true}
                    value={t("select_car")}
                    key={t("select_car")}
                    style={{
                      direction: isRTL === "rtl" ? "rtl" : "ltr",
                      width: "100%",
                      justifyContent: "flex-start",
                      paddingLeft: 10,
                    }}
                  >
                    {t("select_car")}
                  </MenuItem>
                  {cartypes
                    .filter(
                      (carT) =>
                        carT.category === selectedCategory &&
                        carT.active === true
                    )
                    .sort((a, b) => a.pos - b.pos)
                    .map((car) => (
                      <MenuItem
                        dense={true}
                        key={car.name}
                        value={car.name}
                        style={{
                          direction: isRTL === "rtl" ? "rtl" : "ltr",
                          width: "100%",
                          justifyContent: "flex-start",
                          paddingLeft: 10,
                        }}
                      >
                        <img
                          src={car.image}
                          className={
                            isRTL === "rtl"
                              ? classes.carphotoRtl
                              : classes.carphoto
                          }
                          alt="car types"
                        />
                        {car.name}
                      </MenuItem>
                    ))}
                </Select>
              ) : null}
            </Grid>
            <Grid item xs={12} sm={3}>
              <Select
                id="booking-type-native"
                value={bookingType}
                onChange={handleBookTypeSelect}
                className={classes.input}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                variant="outlined"
                fullWidth
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem
                  dense
                  key={"Book Now"}
                  value={"Book Now"}
                  style={{
                    direction: isRTL === "rtl" ? "rtl" : "ltr",
                    width: "100%",
                    justifyContent: "flex-start",
                    paddingLeft: 10,
                  }}
                >
                  {t("book_now")}
                </MenuItem>
                <MenuItem
                  dense
                  key={"Book Later"}
                  value={"Book Later"}
                  style={{
                    direction: isRTL === "rtl" ? "rtl" : "ltr",
                    width: "100%",
                    justifyContent: "flex-start",
                    paddingLeft: 10,
                  }}
                >
                  {t("book_later")}
                </MenuItem>
              </Select>
            </Grid>
            {bookingType === "Book Later" ? (
              <Grid item xs={12} sm={6}>
                <TextField
                  id="datetime-local"
                  label={t("booking_date_time")}
                  type="datetime-local"
                  variant="outlined"
                  fullWidth
                  className={
                    isRTL === "rtl"
                      ? classes.inputRtl
                      : classes.commonInputStyle
                  }
                  InputProps={{
                    className: classes.input,
                    style: { textAlignLast: isRTL === "rtl" ? "end" : "start" },
                  }}
                  value={selectedDate}
                  onChange={onDateChange}
                />
              </Grid>
            ) : null}
            {bookingType === "Book Later" ? (
              <Grid item xs={12} sm={6}>
                <Button
                  size="lg"
                  onClick={handleGetOptions}
                  variant="contained"
                  color="success"
                  className={classes.buttonStyle}
                  disabled={estimateRequested}
                >
                  {estimateRequested ? (
                    <>
                      <CircularProgress size={20} style={{ color: "#FFF", marginRight: 10 }} />
                      {t("calculating") || "Calculating..."}
                    </>
                  ) : (
                    <>
                  <i
                    className="fas fa-car"
                    style={
                      isRTL === "rtl" ? { marginLeft: 5 } : { marginRight: 5 }
                    }
                  />
                  {t("book")}
                    </>
                  )}
                </Button>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Button
                  size="lg"
                  onClick={handleGetOptions}
                  variant="contained"
                  color="success"
                  className={classes.buttonStyle}
                  disabled={estimateRequested}
                >
                  {estimateRequested ? (
                    <>
                      <CircularProgress size={20} style={{ color: "#FFF", marginRight: 10 }} />
                      {t("calculating") || "Calculating..."}
                    </>
                  ) : (
                    <>
                  <i
                    className="fas fa-car"
                    style={
                      isRTL === "rtl" ? { marginLeft: 5 } : { marginRight: 5 }
                    }
                  />
                  {t("book")}
                    </>
                  )}
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
      </Grid>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={optionModalStatus}
        onClose={isBookingLoading ? undefined : handleOptionModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          {/* ADDED two attribs useRebidMod and bidPrice for user bidding below */}
          <BookingModalBody
            classes={classes}
            instructionData={instructionData}
            handleChange={handleChange}
            tripInstructions={tripInstructions}
            auth={auth}
            profileData={profileData}
            selectedCarDetails={selectedCarDetails}
            hours={hours}
            handleHoursChange={handleHoursChange}
            handleIHoursAdd={handleIHoursAdd}
            handleIHoursSubtruct={handleIHoursSubtruct}
            useRebidMod={useRebidMod}
            bidPrice={bidPrice}
          />
          {selectedCarDetails && selectedCarDetails.hasBid ? null : (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
            >
              {auth.profile.swipe_symbol === false ? (
                <Typography color={"primary"} style={{ fontSize: 30 }}>
                  {t("total")} - {auth ? auth.profile.symbol : null}{" "}
                  {estimatedata.estimate
                    ? estimatedata.estimate.estimateFare
                    : null}
                </Typography>
              ) : (
                <Typography color={"primary"} style={{ fontSize: 30 }}>
                  {t("total")} -{" "}
                  {estimatedata.estimate
                    ? estimatedata.estimate.estimateFare
                    : null}{" "}
                  {auth ? auth.profile.symbol : null}
                </Typography>
              )}
            </Grid>
          )}

          {auth.profile.usertype === "customer" ? (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
            >
              <FormControl component="fieldset">
                <FormLabel component="legend">{t("payment_mode")}</FormLabel>
                <RadioGroup
                  row
                  name="payment_mode"
                  value={payment_mode}
                  onChange={handleChange}
                >
                  {radioProps.map((element, index) => (
                    <FormControlLabel
                      key={element.cat}
                      value={index}
                      control={<Radio />}
                      label={element.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid>
          ) : null}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading || isBookingLoading ? (
              <DialogActions
                style={{ 
                  justifyContent: "center", 
                  alignContent: "center",
                  flexDirection: "column",
                  padding: "20px"
                }}
              >
                <CircularProgress size={40} />
                <Typography style={{ marginTop: 15, fontSize: 16, fontWeight: 500 }}>
                  {loading ? (t("checking") || "Checking...") : (t("processing_booking") || "Processing booking...")}
                </Typography>
                <Typography style={{ marginTop: 5, fontSize: 14, color: "#666" }}>
                  {t("please_wait") || "Please wait..."}
                </Typography>
              </DialogActions>
            ) : (
              <Grid item xs={12}>
                <Button
                  onClick={handleOptionModalClose}
                  variant="contained"
                  color="primary"
                  disabled={isBookingLoading}
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={confirmBooking}
                  variant="contained"
                  color="primary"
                  disabled={isBookingLoading}
                  style={
                    isRTL === "rtl" ? { marginRight: 10 } : { marginLeft: 10 }
                  }
                >
                  {isBookingLoading ? (
                    <>
                      <CircularProgress size={20} style={{ color: "#FFF", marginRight: 10 }} />
                      {t("processing") || "Processing..."}
                    </>
                  ) : (
                    t("book_now")
                  )}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={walletModalStatus}
        onClose={handleWalletModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginBottom: "20px" }}
          >
            <Typography style={{ fontWeight: "bolder", marginBottom: 10 }}>
              {t("payment")}
            </Typography>
            {bookingdata && bookingdata.booking ? (
              <Typography color={"primary"} style={{ fontSize: 30 }}>
                {auth.profile.swipe_symbol === false
                  ? auth.profile.symbol + bookingdata.booking.mainData.trip_cost
                  : bookingdata.booking.mainData.trip_cost +
                    auth.profile.symbol}
              </Typography>
            ) : null}
            <Typography>
              {t("use_wallet_balance") +
                " " +
                (auth.profile.swipe_symbol === false
                  ? auth.profile.symbol + auth.profile.walletBalance
                  : auth.profile.walletBalance + auth.profile.symbol) +
                ")"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {isWalletPaymentLoading ? (
              <DialogActions
                style={{ justifyContent: "center", alignContent: "center" }}
              >
                <CircularProgress />
                <Typography style={{ marginLeft: 10 }}>
                  {t("processing_payment") || "Processing payment..."}
                </Typography>
              </DialogActions>
            ) : (
              <>
            <Button
              onClick={handleWalletModalClose}
              variant="contained"
              color="primary"
                  disabled={isWalletPaymentLoading}
            >
              {t("cancel")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: 10 }}
              onClick={handleWalletPayment}
                  disabled={isWalletPaymentLoading}
                >
                  {isWalletPaymentLoading ? (
                    <>
                      <CircularProgress size={20} style={{ color: "#FFF", marginRight: 10 }} />
                      {t("processing") || "Processing..."}
                    </>
                  ) : (
                    t("paynow_button")
                  )}
            </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModalStatus}
        onClose={handlePaymentModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          {providers &&
          selectedProvider &&
          bookingdata &&
          bookingdata.booking ? (
            <form action={selectedProvider.link} method="POST">
              <input
                type="hidden"
                name="order_id"
                value={bookingdata.booking.booking_id}
              />
              <input
                type="hidden"
                name="amount"
                value={bookingdata.booking.mainData.trip_cost}
              />
              <input
                type="hidden"
                name="currency"
                value={auth.profile.currency_code}
              />
              <input
                type="hidden"
                name="product_name"
                value={t("bookingPayment")}
              />
              <input
                type="hidden"
                name="first_name"
                value={auth.profile.firstName}
              />
              <input
                type="hidden"
                name="last_name"
                value={auth.profile.lastName}
              />
              <input type="hidden" name="quantity" value={1} />
              <input
                type="hidden"
                name="cust_id"
                value={bookingdata.booking.mainData.customer}
              />
              <input
                type="hidden"
                name="mobile_no"
                value={bookingdata.booking.mainData.customer_contact}
              />
              <input
                type="hidden"
                name="email"
                value={bookingdata.booking.mainData.customer_email}
              />
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ marginBottom: "20px" }}
              >
                <FormControl fullWidth>
                  <FormLabel component="legend">{t("payment")}</FormLabel>
                  <Select
                    id="selectedProviderIndex"
                    name="selectedProviderIndex"
                    value={selectedProviderIndex}
                    label={t("payment")}
                    onChange={handleChange}
                    style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    {providers.map((provider, index) => (
                      <MenuItem key={provider.id} value={index}>
                        <img
                          style={{ height: 24, margin: 7 }}
                          src={icons[provider.id]}
                          alt={provider.id}
                        />{" "}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Button
                  onClick={handlePaymentModalClose}
                  variant="contained"
                  color="primary"
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ marginLeft: 10 }}
                  onClick={handlePaymentModalClose}
                >
                  {t("paynow_button")}
                </Button>
              </Grid>
            </form>
          ) : null}
        </Grid>
      </Modal>
      <AlertDialog
        open={bookingdata.error.flag}
        onClose={handleBookingErrorClose}
      >
        {bookingdata.error.msg}
      </AlertDialog>
      <AlertDialog
        open={estimatedata.error.flag}
        onClose={handleEstimateErrorClose}
      >
        {estimatedata.error.msg}
      </AlertDialog>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}
